import React from 'react'

export default {
  afangi: '3a',
  forSale: true,
  btnSpan: 4,
  title: 'Áfangi 3A',
  key: 'afangi-3a',
  // subtitle: 'Úthlutun lokið',
  rect: {
    className: 'bg-primary text-white',
    props: {
      transform: 'translate(2930, 1265) scale(0.8)',
      width: 470,
      height: 180,
    },
  },
  path: {
    d: 'm2888.2 1630.3 15-21.1 7.4-13.8 3.4-14.4 3.4-22.4 2.5-19.4 14.2-99.5-40.7-9.6 17.7-93.7-231.4-53.4-9.8 37.8-123.5-29.2 34-111.4-19.3-37.6 23-75.8 533 116.3 59.7 12.8 111.4 32.7 105.4 32.6 34.9 11.4 18.5 4.4 32.1 3 26.9-.8 15.7-2.6 12.9-2.5 11.7 3.3 20.9-2 47.2 30.9-1.2 5.6 38.9 30 40.1 23.3 93.6 69-5.5 5.4-16.2 10-19.3 9.5-18.5 7.8-17.2 6.3-24.4 6.9-18.5 4.5-26.8 4.7-32.8 3.8-39.4 1.3-42.7-1.4-51.1-5.3-43.8-7.5-30.2-7.5-116.1-27.4-9.2 112.5-136.6-32-63.2-13.7-8.8 59.6-13.4 91.1-3.3 9.4-5.4 8.2-6.2 7.4-7.3 6.5-9.9 6.1-70.7-36.8z',
  },
  takkamynd: {
    image: {
      src: require('images/lodir/skogarhverfi/cam03.jpg'),
      width: 4000,
      height: 2250,
    },
    list: [
      {
        lod: 'alfalundur-28-32',
        d: 'M2057.3 200l17.68 13.1-1.93 132.31-51.07-.2V330l-68.1-.92v11l-155-2.13v-8.72l-21-.16 10.19-133.36 61.66.81.7-11.73h30.16l1.15 12.93s50.76 0 50.92-.08 0-11.14 0-11.14 29.68.7 29.89.64.38 12.11.38 12.11l51.54.64.58-12.32 29.42.43.2 11.78z',
      },
      {
        lod: 'alfalundur-31-43',
        d: 'M2202.57 514.36l21.54.75.53-13.5 71.68.53.64 33.11 55.05.75-14.93-367.21h-52.01l-.64-31.74-65.65-.56-.48 13.34h-20.58l-1.04 17-56.29-.93-.52 365.91 61.84.55.86-18z',
      },
      {
        lod: 'alfalundur-34-42',
        d: 'M2022.06 355.95l-.08-10.77v-15.19l-68.1-.92v11.01l-.28 14.28-84.86-1.23-17.86 285.51-1.26 53.04 18.48.48.64 18.16 22.1.08 1.12-18.24 58.83 1.34v18l23.03.43.64-18.43 58.18.96v18.86l34.49.54 5.8-357.19-50.87-.72z',
      },
      {
        lod: 'alfalundur-45-55',
        d: 'M2296.96 535.25l-.64-33.11-71.68-.53-.53 13.5-21.54-.75-.86 18-61.84-.55-.83 345.87 19.17 16.39 209.79 4.21L2352.01 536l-55.05-.75z',
      },
      {
        lod: 'akralundur-43-51',
        d: 'M2032.64 694.46l-58.18-.96-.64 18.43-23.03-.43v-18l-58.83-1.34-1.12 18.24-22.1-.08-.64-18.16-18.48-.48 1.26-53.04-230.63-4.01-27.62 248.86 451.93 8.76 19.93-15.91 2.64-162.48-34.49-.54v-18.86z',
      },
      {
        lod: 'akralundur-33-41',
        d: 'M1599.79 686.75l-21.22 198.75s-424.57-11.25-425.14-11.25-18.32-2.46-18.32-2.46-16.18-4.29-16.82-4.29c-.31 0-4.66-1.92-9.17-3.94-5-2.25-10.23-4.63-10.23-4.63s-3.84-1.91-7.85-3.88c-4.28-2.1-8.75-4.26-9-4.26s-4.52-3.32-8.5-6.43c-3.53-2.76-6.82-5.36-6.82-5.36l45.35-73.15-3.78-11.09 44.68-53.2 22.5-37.2 27.88 8.51 13.26 3.7 16.07 3.3 15 3 18 3 36.32 1.29z',
      },
      {
        lod: 'akralundur-28',
        d: 'M1674.79 974.88h0l-179.95-3.4-25.45 199.13 185.27 3.65h0l20.13-199.38z',
      },
      {
        lod: 'akralundur-30',
        d: 'M1858.62 978.35l-183.83-3.47-20.13 199.38 194.98 3.84 8.98-199.75h0z',
      },
      {
        lod: 'skogarlundur-1',
        d: 'M2355.14 1167.71l1-.3L2372 987.88l-69.71-1.09-.31-18.68-78.64-1.72-1.72 18.86-57.62-.75-22.82 15.5-23 134.41-.19 1.1.74.47z',
      },
      {
        lod: 'skogarlundur-2',
        d: 'M2042.18 981.82l-183.56-3.47h0l-9 199.75 179.79 3.54s20.68-108.43 20.68-108.59 5-26.46 5-26.46l3.16-16.39 2.36-13.66 1.28-17.63z',
      },
      {
        lod: 'skogarlundur-4',
        d: 'M1924.91 1371.82l1.13 7.72 66.75 5.46 1.71-10.39 2.68-19.29 2.36-16.71 3.75-19.82 6.48-33.19 6.43-33.67 9.8-54.08-87.11-.67.22-7.5-80.25-10.61-3.75 15.11-97.61-1.93-12.64 172.39-.12 2.34 138.39 9.42 41.78-4.58z',
      },
      {
        lod: 'skogarlundur-3',
        d: 'M2215.16 1330.36H2273v9.38s57.37 8.78 59.41 9.37h0l23.44-178.5.28-3.2-1 .3-236.44-31.71-.74-.47-30.88 175.2-.33 2h0z',
      },
      {
        lod: 'skogarlundur-6',
        d: 'M2000 1529.16l-4.86-25.07-2.25-26.63-2.35-29.03 1.17-39.75 1.08-23.68h0l-66.75-5.46-1.13-7.72-41.78 4.58-138.39-9.42-.95 19.52-1.72 37.93v43.5l3 54.43 8.36 51.64 10.61 43.39 243.16-52.23-4.02-16.55-3.18-19.45z',
      },
      {
        lod: 'skogarlundur-5',
        d: 'M2339.75 1502.51h0l-.89-2.33s-4-12.43-4-13-3.1-12.1-3.1-12.1l-2.79-13.5-1.66-13.45-1.29-14.78-.32-14.31.65-15.11 1.12-14.3 1.93-15.27 3-25.28c-2-.59-59.41-9.37-59.41-9.37v-9.38h-57.86l-128.42-17.66h0l-4 23.6s-5.3 36.32-5.3 36.81-3.38 35.84-3.38 35.84v43.55l4 35.52 6.91 40.18 8.84 35h0z',
      },
      {
        lod: 'skogarlundur-8',
        d: 'M2071.96 1721.38l-13.17-23.79-17.68-35.68-9.16-23.14-9.32-22.18-6.75-21.21-8.68-30.22h0l-243.16 52.23h0l9.48 38.57 17.19 46.45 14.31 35.68 20.57 43.55 21.7 39 23.14 37.93 4.75 7.01 211.57-120.74-14.79-23.46z',
      },
      {
        lod: 'skogarlundur-7',
        d: 'M2388.04 1590.5l-9.75-14.14-7.83-11.79-8.03-12.75-7.18-13.61-5.68-11.57-5.46-12.75-4.36-11.38-245.93 60.72 10.13 29.41 13.98 34.24 14.14 29.25 14.47 24.75 16.23 26.35 19.28 26.04 23.31 27.8 23.62 25.88 24.43 23.46 17.68 15.91 65.01-70.87 11.73-13.58 8.92-11.98 8.04-12.53 7.5-12.75 6.75-13.93 5.78-14.36 4.93-15.96 4.61-18.65 3-17.78.75-19.82-10.07-13.61z',
      },
      {
        lod: 'skogarlundur-10',
        d: 'M2203.43 1879.36l-21.7-19.13-23.3-24.75-20.73-22.66-17.52-21.37-19.29-25.24-14.14-21.37h0l-211.57 120.74 20.11 29.63 31.71 41.58 36 41.78 37 36.22 28.57 27.42 33.86 28.72 14.36 10.71 152.19-179.62-25.55-22.66z',
      },
    ],
  },
}

// 3b:
// overview path: M2143.89 186.12h19.89l1.72-25.4 99.23 1.42 1.5 26.2h37.69l57.88 3h11.95l2.84-27 93.19 1 2.41 26.68 36.72.33 4.07-25.71 73.72-.09 4.34 28.12 15-.08 62.75 1.62h12.69l4.08-27.8 83.41 1.31 4.9 22.9 24.51.09 5-22.18 83.49 1.6 5.79 26.2h7.09l73.5-.43h20.36l4.66-19.18 11.95-.32 2.89-10.55 45.64.69 6.22 21.22 7.61.75 2.46 8.57 30.11.75 60.53 181.28 39.86 132.54 43.34 132.8 61.07 186.38-128.77 112.74 13.71 9.11 9.86-8.89 76.82 46.82-4.82 11.46 24.86 15.64 8.3 24.46 59.3 35.33-38.65 31.85 86.55 53.54-4.07 9.86 6.85 4.29 38.76 42.48-67.43 68.12-81.74 82.57-22.77 34L3337 1441l120.41 52.61-55.16 59.57-13.87 14.82-13.19 12.8-13.8 12.38-12.85 10.5-24.11 17.15-4.61 2.78-24.75 14.68-26.25 12.54-19.28 8.14-17 6.43-35.25 10.93-34.93 7.82-21.53 3.32-30.11 4.07-27.62 3.56-17.44 3.3-17.35 4.26-18 5.09-20.79 7.12-16.08 6.35-23.22 11.49-22.55 12.72-21 14.9-26.23 22.82-13.93 13.82-14 12.8-16.24 14.38-19.28 15.46-21.38 16.53-31.09 21.61-22.4 13.25-25.32 14.23-35.68 18.8-30.69 12.75-29.68 12.7-35.46 12.52-28.29 8.73-38.46 10.27-60.54 12.27-39 5.84-30.43 3.43-27.86 2.35-28.57 1-23.18.65-55.92-.7-175.56-4.51-174.8-3.58-68.84-2.27-175.84-3.98-123.68-3.73-25.46-1.89-20.63-2.74-38-5.78-27-5.47-32.94-7.71-29.29-8.68-29.09-9.48-27.48-11.25 89.86-146.77 35.09 12.16 26.89 7.66 36.45 8 35.92 5.3 28.61 3.38 22.81.62 7.94-59.07 45.27-385.05 2.22-13 29.2-252.63 7.31-59.41 30-257.2 17.31-11L1942 661v-3.75l99.38-60.11 186.32-114.48-.11-1.61 16.24-9.64 5 3.7 9.38-5.25 8.36 5.19 53.51 1.45-6.08-106.29-170.13-1.44z
